<template>
    <div>
        <div class="modal right" tabindex="-1" role="dialog" id="exampleModalLong">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">{{$t('Add to Language Mapper')}}</h6>
                        <button
                            class="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                            v-on:click="closeDialog()"
                            title="Close"
                            >
                            <span aria-hidden="true">
                                <cancel-icon tabindex="0" class="close-icon categorybrowse" style="height: 30px !important;
                                    width: 30px !important;
                                    color: #fff;">
                                </cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body" ref="mappersList">
                        <div class="value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields">
                            <div style="width: 18%;padding-top: 14px;text-align: end;padding-inline-end: 8px;word-break: break-all;" :title="profileName">
                              {{profileName}}
                            </div>
                            <!-- <ul class="tags-display-ul p-0 w-100 m-0" style=" display: grid;"> -->
                                <!-- <div style="display: grid;"> -->
                                    <div style="display:inline-flex;width:82%">
                                        <table class="table-scroll" style="background: transparent; width: 100%">
                                            <thead>
                                                <tr>
                                                    <th scope="col" style="width: 30%" class="text-left col-md-3"></th>
                                                    <th scope="col" style="width: 60%" class="text-center col-md-6"></th>
                                                    <th scope="col" style="width: 10%" class="text-center col-md-1"></th>
                                                </tr>
                                            </thead>
                                            <tbody class="body-half-screen">
                                                <template v-for="op in selectedLangList">
                                                    <tr :key="op._id" class="comm-table-row">
                                                        <td class="text-left" style="width:30%">
                                                            <div style="display:flex;width:100%;">
                                                                <span class="key-style" style="width:10% !important"> In </span>
                                                                <Multiselect
                                                                    :value="labelOflanguagesList[op.uuid]"
                                                                    :options="languagesList"
                                                                    :searchable="true"
                                                                    :close-on-select="true"
                                                                    :allow-empty="false"
                                                                    @select="updateRowType($event,op)"
                                                                    label="name"
                                                                    deselectLabel=""
                                                                    selectLabel=""
                                                                    selectedLabel=""
                                                                    track-by="_id"
                                                                    :show-labels="true"
                                                                    :placeholder="$t('Select Language')"
                                                                    open-direction='below'>
                                                                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                        <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
                                                                    </div>
                                                                </Multiselect>
                                                            </div>
                                                        </td>
                                                        <td class="text-center" style="width:65%">
                                                            <div class="comm-screen-profile-fields" style="display:flex;width:100%;">
                                                                <span class="key-style"> called as </span>
                                                                <template v-if="!isEditing(op.uuid) && !newField && isNewRow != op.uuid">
                                                                <div class="fields-on-non-edit-mode" style="width:100%;"
                                                                    v-on:dblclick.stop="editingKey = op.uuid">
                                                                    <span v-if="op.name">{{op.field_alias}} </span>
                                                                    <span v-else class="empty-field-text-styles">NONE</span>
                                                                    <edit-icon v-on:click.native="enableEditMode(op.uuid)" class="editIconClass"></edit-icon>
                                                                </div>
                                                            </template>
                                                                <template v-else-if="isEditing(op.uuid) || newField || isNewRow == op.uuid">
                                                                    <div class="input-field-wrapper">
                                                                        <input
                                                                            :placeholder="$t('Add Value')"
                                                                            type="text"
                                                                            id="name_value"
                                                                            class="rounded text-light comm-input-field-style"
                                                                            style="max-height: 300px;margin-bottom: 8px;margin-top:4px;height: 38px;margin-inline-start:1px;"
                                                                            v-model="op.field_alias"
                                                                            autocomplete="off"
                                                                        />
                                                                        <template v-if="(isEditing(op.uuid) || isNewRow == op.uuid) && !newField">
                                                                            <div  class="save-icons" style="margin-inline-start: 10px;width: 75px;display: inline-flex;align-items: center;">
                                                                                <save-icon v-on:click.native="saveFieldComponentsValue(op.uuid)"></save-icon>
                                                                                <cancel-icon v-on:click.native="cancelEditMode(op.uuid)"></cancel-icon>
                                                                            </div>
                                                                        </template>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </td>
                                                        <td title="Delete" style="width:10%">
                                                            <div style="display: inline-flex;width: 100%;align-items: center;justify-content: center;">
                                                                <delete-icon class="delete-btn"  @click.native="deleteLoadType('language_alias_mapper', op.uuid,op.name)"
                                                                                style="float: inline-start;margin:8px;height:20px !important;width:20px !important;" title="Delete Entry"></delete-icon> <!--:style="(isEditing(op.uuid) || (op._id == '0'))?'inset-inline-start :41px;':'inset-inline-start :10px;'"-->
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <tr class="comm-table-row">
                                                    <td class="text-left" style="width:30%;padding-inline-start: 28px;">
                                                        <div style="" class="add-screens-styles" @click="addNewLangRow()">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                            </svg>
                                                            {{$t('Add Language')}}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                <!-- </div> -->
                            <!-- </ul> -->
                        </div>
                    </div>
                    <div class="modal-footer p-0 primary-btn-style">
                        <button class="btn btn-outline-secondary ml-1" title="Close" @click="closeDialog()">{{$t('Cancel')}}</button>
                        <button v-if="newField" class="btn btn-outline-primary ml-1" title="Save Dictionary" @click="saveLangDictMapper()">{{$t('Save')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
  
  
<script>
    import {mapActions} from "vuex";
    import Utils from "../../components.utils.js";
    import Constants from "../../components.constants.js";
    import Multiselect from 'vue-multiselect';
    import CancelIcon from "../core/InlineCancelField.vue";
    import editIcon from "../core/InlineEditField.vue";
    import saveIcon from "../core/InlineSaveField.vue";
    import deleteIcon from "../core/InlineDeleteIcon.vue";
  
    export default {
        props: ["selectedFieldID","newField", "selectedFieldResp", "profileName"],
        components:{
            "cancel-icon": CancelIcon,
            "Multiselect":Multiselect,
            "edit-icon":editIcon,
            "save-icon":saveIcon,
            "delete-icon":deleteIcon
        },
        data() {
            return {
                options:{chunk:5},
                labelOflanguagesList:{},
                languagesList:[],
                selectedLangList : [],
                langDisplayValMapper:[],
                editingKey:null,
                isNewRow:null,
                selectedLoadwhenFilter:[],
            };
        },
        methods: {
            closeDialog(){
                this.$emit("close")
            },
            style(name){
                let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
                }
                return style
            },
            enableEditMode(keyUuid){
                if(this.editingKey){
                    this.cancelEditMode(this.editingKey)
                }
                this.isNewRow=null;
                this.editingKey = keyUuid;
            },
            isEditing(keyUuid) {
                return keyUuid === this.editingKey;
            },
            saveLangDictMapper(){
                let filteredMapper = this.selectedLangList.filter(op=>op._id != Constants.loadEmpty)
                let emptyEntry = filteredMapper.find(op=>op.field_alias.trim().length <= 0)
                if(emptyEntry){
                    alert("Please add valid Language mappers.")
                    return
                }
                this.$emit('updateLangMapper', filteredMapper);
            },
            saveFieldComponentsValue(uuid){
                let loadM = this.selectedLangList.find(e => e.uuid == uuid)
                if(loadM){
                    if(loadM.field_alias && loadM.field_alias.trim().length <= 0){
                        alert("Please add valid value");
                        return
                    }
                    this.updateLoadType('language_alias_mapper')
                }
            },
            updateRowType(newVal,oldVal){
                if(typeof newVal != "undefined" && typeof oldVal != "undefined"){
                    let oldValLabel = oldVal.name
                    if(this.selectedLoadwhenFilter.includes(newVal.name)){
                        alert("Already selected");
                        return;
                    }
                    let isTypeExists = false;
                    for(let loadType of this.selectedLangList){
                        if(loadType.uuid == oldVal.uuid){
                            isTypeExists = true;
                            loadType._id = newVal._id;
                            loadType.name = newVal.name;
                            loadType.code = newVal.code;
                            this.isNewRow = loadType.uuid;
                            this.editingKey = loadType.uuid;
                            this.labelOflanguagesList[loadType.uuid] = {"name":newVal.name};
                            if(this.selectedLoadwhenFilter.includes(oldValLabel)){
                                this.selectedLoadwhenFilter.splice(this.selectedLoadwhenFilter.indexOf(oldValLabel), 1);
                            }
                            this.selectedLoadwhenFilter.push(newVal.name);
                            if(Object.keys(newVal).includes("_id")){
                                loadType.field_alias = ""
                            }
                        }
                    }
                    if(!isTypeExists){
                        let newUuid = Utils.getUUID();
                        this.labelOflanguagesList[newUuid] = {"name":newVal.name};
                        let newEntry = {
                            "_id":newVal._id,
                            "uuid":newUuid,
                            "name":newVal.name,
                            "field_alias": "",
                            "code":newVal.code
                        }
                        this.selectedLoadwhenFilter.push(newVal.name);
                        this.selectedLangList.push(newEntry);
                        this.isNewRow = newUuid;
                        this.editingKey = newVal.uuid;
                    }
                }
            },
            addNewLangRow(){
                let newUuid = Utils.getUUID();
                this.labelOflanguagesList[newUuid] = "";
                this.selectedLangList.push({
                    "_id":Constants.loadEmpty,
                    "uuid":newUuid,
                    "name":"Select Language",
                    "field_alias":"",
                    "code":"",
                })
                if(this.$refs.mappersList){
                    this.$refs.mappersList.scrollTop = this.$refs.mappersList.scrollHeight;
                }
            },
            updateLoadType(dictKey){
                if(this.newField){
                    return
                }
                let emptyEntry = this.selectedLangList.find(op=>op.field_alias.trim().length <= 0)
                if(emptyEntry){
                    alert("Please add valid Language mappers.")
                    return
                }
                let payload = {params:{_id: this.selectedFieldID}}
                payload[dictKey] = this.selectedLangList;
                this.updateExistingCustomMetadata(payload).then((data) => {
                    if (Utils.isAcceptedStatusCode(data.statusCode)){
                        this.$toast.success(data.message);
                        this.editingKey = null;
                        this.isNewRow = null;
                    } else {
                        this.$toast.error(data.message);
                    }
                });
            },
            deleteLoadType(loadType, loadTypeUuid,value){
                if(typeof loadType == "undefined"){
                    return;
                }
                if(loadType == "language_alias_mapper"){
                    if(this.selectedLoadwhenFilter.includes(value)){
                        this.selectedLoadwhenFilter.splice(this.selectedLoadwhenFilter.indexOf(value), 1);
                    }
                    let tIndex = this.selectedLangList.findIndex(t=>t.uuid==loadTypeUuid);
                    this.selectedLangList.splice(tIndex,1);
                    if(value.trim().length > 0){
                        this.selectedLangList = this.selectedLangList.filter(op=> op._id != Constants.loadEmpty)
                        this.updateLoadType("language_alias_mapper");
                    }
                    }
            },
            cancelEditMode(uuid){
                let indx = this.selectedLangList.findIndex(op=>op.uuid == uuid)
                if(indx >= 0){
                    let oldValLabel = this.selectedLangList[indx].name;
                    if(this.selectedLoadwhenFilter.includes(oldValLabel)){
                        this.selectedLoadwhenFilter.splice(this.selectedLoadwhenFilter.indexOf(oldValLabel), 1);
                    }
                    let fetchEntry = this.selectedFieldResp.language_alias_mapper.find(op=>op.uuid == uuid)
                    if(fetchEntry){
                        this.$set(this.labelOflanguagesList[uuid], 'name', fetchEntry['name'])
                        this.$set(this.selectedLangList[indx], "_id", fetchEntry['_id'])
                        this.$set(this.selectedLangList[indx], "name", fetchEntry['name'])
                        this.$set(this.selectedLangList[indx], "code", fetchEntry['code'])
                        this.$set(this.selectedLangList[indx], "field_alias", fetchEntry['field_alias'])
                    }else{
                        this.selectedLangList.splice(indx, 1);
                    }
                }
                this.editingKey = null;
                this.isNewRow = null;
            },
            reloadFilters(){
                // Deep copying selectedFieldResp["language_alias_mapper"] , so that on selectedLangList update the prop will not be changed
                this.selectedLangList = JSON.parse(JSON.stringify(this.selectedFieldResp["language_alias_mapper"]));
                if(typeof this.selectedLangList != "undefined" && this.selectedLangList.length > 0){
                    for(let loadC of this.selectedLangList){
                        this.labelOflanguagesList[loadC.uuid] = {"name":loadC.name};
                        this.selectedLoadwhenFilter.push(loadC.name);
                    }
                }else{
                    this.addNewLangRow();
                }
            },
            ...mapActions("customMetadata",["updateExistingCustomMetadata", "getLanguagesForFieldAliasConfig"]),
        },
        watch: {
            'selectedFieldResp': function(val){
                if(val){
                    this.reloadFilters()
                }
            }
        },
        async created(){
            let data = await this.getLanguagesForFieldAliasConfig({params:{enabled:true}});
            if (Constants.acceptedStatusCodes.includes(data.statusCode)){
                this.languagesList = data.languages;
            }
            this.reloadFilters()
        },
    };
</script>
  
<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $border-on-hover: 1px solid #61707d;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $icon-hover:#2c3339;
  
    .modal-dialog {
        max-width: 810px;
        width: 810px;
        max-height: 100%;
        margin: 0;
        padding: 0;
    }

    .modal{
        transition: opacity .3s ease;
    }

    .modal-content {
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            // overflow: auto;
            background: #1a1e21;
            padding: 1rem;
            padding-inline-end: 0.4rem !important;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        
    }
    .modal-header .close {
        margin: 0px !important;
        padding:0px !important;
    }
    .modal:before {
        content: '';
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    .btn{
        font-size:$input-field-and-label-font-size !important;
        height:100%;
    }

    .border{
        border: $border-color !important;
    }

    .modal-header{
        align-items: center
    }

    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height: 58px;
        .modal-title{
            color:$text-color;
        }
    }

    .primary-btn-style{
        padding: 8px 16px !important;
        button{
            height: 35px;
            width: 75px;
            font-size:$input-field-and-label-font-size;
        }
    }

    .secondary-btn-style{
        color:$text-color;
    }

    .key-style {
        color: $dull-text-color;
        width: 16%;
        font-size: $input-field-and-label-font-size;
        margin-top: 11px;
    }

    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }

    .empty-field-text-styles{
        color:$none-text-color;
    }

    .input-field-wrapper{
        display: inline-flex;
        width: 100%;
        position: relative;
        // svg{
        //     position: absolute;
        //     inset-inline-end :-27px;
        //     top: 12px;
        //     height:25px;
        // }
    }

    .fields-on-non-edit-mode{
        width:70%;
        // display:inline-flex;
        line-height:46px;
        text-align: start;
    }

    .bigger-checkboxes {
        height: 30px;
        width: 20px;
        position:relative;
    }
    input[type="checkbox"]:after {
        line-height: 1.5em;
        content: "";
        display: inline-block !important;
        width: 22px !important;
        height: 21px !important;
        margin-top: 5px !important;
        margin-inline-start: -1px !important;
        border: $border-color !important;
        border-radius: 0.25em !important;
        background: $primary-background !important;
    }
    input[type="checkbox"]:checked:after {
        content: "✔";
        color: $active-blue !important;
        position: absolute !important;
        font-size: 16px !important;
        line-height: 1 !important;
        transition: all 0.2s !important;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px !important;
        padding-top: 2px !important;
    }
  
    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }
  
    .tags-display-ul{
        list-style-type: none;
    }
    
    .tags-display-ul .show-tags-delete{
        visibility:hidden;
    }
    
    .searched-metadata-display-fields{
        height: auto;
        // overflow: auto;
        width: 100%;
    }
    
    .view-tags:hover .show-tags-delete{
        visibility: visible;
    }
    
    .view-tags:hover {
        border: $border-on-hover !important;
    }
  
    .key-style {
        color: $dull-text-color;
        width: 34%;
        text-align: center;
        font-size: $input-field-and-label-font-size;
        padding-inline-start: 5px;
        padding-inline-end: 5px;
        margin-top: 13px;
    }
    
    .activeTag{
        color: $active-blue !important;
    }
    .view-tags{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border: $border-color !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: center;
        width:auto !important;
        padding-inline-start: 12px !important;
        justify-content: center;
        padding-top: 1px !important;
        div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
        }
    }
  
    .view-fields-styles{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: start;
        width:98% !important;
        padding-inline-start: 12px !important;
        justify-content: start;
        padding-top: 1px !important;
        div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 14px;
            line-height: 32px;
            color: $secondary-text-color;
            text-align:end;
        }
    }
  
    .comm-input-field-style{
        background: $primary-background!important;
        width: 100%;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: 42px;
    }

    .comm-tags-field-wrapper-style{
        background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        min-height: $input-field-height;
        margin-top:1px;
        margin-bottom:1px;
        border-radius: 4px;
    }
  
    ::v-deep{
        .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
            background: $primary-background;
            border-bottom: $border-color;
        }
        .mx-input{
            background-color: $primary-background  !important;
            border: none !important;
            color: $text-color !important;
        }
        .mx-datepicker-main{
            border: $border-color !important;
            background: $secondary-background-color !important;
        }
        .mx-calendar-content .cell:hover{
            background-color: $bg-color-on-hover !important;
        }
        .mx-datepicker-range{
            width:auto;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-icon-calendar{
            color:$text-color;
        }
    }
  
    .name-style{
        width: 100%;
        text-align: start;
        padding-top: 0px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
        .slug-ellipsis{
            white-space: nowrap;
            max-width: 350px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .input-fields{
        border: none;
        border-radius: 0px !important;
        max-height: 345px;
        overflow: auto;
        // margin-inline-start:5px;
        // margin-bottom: 7px;
    }
  
    .input-fields:focus{
        outline: unset;
        border-bottom: 1px solid #0373ee !important;
    }
    
    .focusField{
        input:focus, select:focus{
          border:none !important;
        }
    }
    
    .tags-wrapper{
        position: absolute;
        inset-inline-end: 0px;
    }
    svg {
        color: #666666;
    }
    
    svg:hover {
        color: $text-color;
    }
  
    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        width: 100%;
        thead {
            color: $dull-text-color !important;
            position: relative;
            th{
                position: sticky;
                top: 0;
                background: $primary-background;
                z-index:9;
                text-align: start;
                padding:0px;
                border:none;
            }
        }
        tbody {
            width: 100%;
            // overflow: auto;
            font-weight: 500;
            tr{
                height:40px;
                border-bottom: 1px solid $primary-background;
                padding:0px;
            }
        }
    }
  
    .delete-btn {
        visibility: hidden;
    }
    .comm-table-row:hover .delete-btn {
        visibility: visible;
        position: relative;
        // inset-inline-start :18px;
    }
    
    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }
  
    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }
    
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }
  
    .height-set-for-component {
        height: calc(100% - 120px);
    }
  
    ::v-deep{
        .multiselect{
            width:240px !important;
            margin: 3px 0px;
        }
        .multiselect__content-wrapper{
            display:none;
        }
        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
            background: $primary-background !important;
            border: $border-color !important;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
            color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__placeholder {
            padding-top: 0px;
            margin-bottom:0px;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
        }
        .multiselect__single{
            padding-top:3px;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: fixed !important;
            display: block;
            background: $text-color;
            width: 240px !important;
            max-height: 240px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
            background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto;
            min-height: 38px;
        }
    }
  
    // .browse-icon{
    //     position: relative;
    //     inset-inline-start :8px;
    //     top: 8px;
    // }
    
    .table td, .table th {
        border-top: none;
        padding:0px;
    }
  
    .display-as-tags{
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: start;
        float: inline-start;
    }
    
    .select-catalog-field{
        width: 101%;
        .name-style{
            width:100%;
        }
    }
  
    .editIconClass{
        visibility: hidden;
    }
    
    .comm-screen-profile-fields:hover{
        .editIconClass{
            visibility: visible;
            margin-inline-start: 8px;
        }
    }
  
    .user-name-or-image-in-selected-option{
        border: $border-color;
        height: 27px;
        width: 27px;
        border-radius: 5px;
        text-align: center;
        line-height: 26px;
        text-transform: uppercase;
        margin-top: -1px;
        margin-inline-start: -1px;
    }
  
    .tags-style{
        display: inline-flex;
        margin-inline-end: 5px;
        margin-bottom: 5px;
        height: 27px;
        margin-inline-start: 3px;
        float:inline-start;
        .user-name-display-as-tags{
            line-height: 27px;
            margin: 0px 5px;
            width:auto;
        }
    }
    .add-screens-styles{
        display: inline-flex;
        height: 45px;
        border: 1px solid $add-button-border-color;
        border-radius: 10px;
        width: 240px;
        // margin: 8px 10px 8px 0px;
        margin-block: 8px;
        margin-inline-start: 0;
        margin-inline-end: 10px;
        color: $add-button-text-color;
        font-size: 15px;
        align-items: center;
        justify-content: center;
        svg{
            margin-inline-end: 7px;
            color:$add-button-text-color !important;
        }
    }

    .add-screens-styles:hover{
        border: 1px solid $add-button-border-on-hover;
        color:$add-button-text-color-hover;
        svg{
            color:$add-button-text-color-hover !important;
        }
    }
</style>